module.exports = __webpack_public_path__ + "static/media/trending_soon_hero_mobile.91af3aaa.png";